module.exports = __webpack_public_path__ + "img/accept.04f36ae4.svg";